import React from 'react';
import ReactDOM from 'react-dom/client';
import { Providers } from './app/providers';
import App from './app/App';
import './app/theme/css-vars.css';
import './app/theme/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);
